import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=633355ac"
import script from "./FindPassword.vue?vue&type=script&lang=js"
export * from "./FindPassword.vue?vue&type=script&lang=js"
import style0 from "./FindPassword.vue?vue&type=style&index=0&id=633355ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports